import React from 'react'
import eduService from '../Service/eduService'
import FormInput from './formTambah'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import {config} from '../Config/config'

export default class index extends React.Component {
    user = localStorage.getItem(config.userid)
    eduModel = {
        name: "",
        create_by: this.user,
        create_on: "",
        modified_by: this.user,
        modified_on: "",
        deleted_by: this.user,
        deleted_on: "",
        is_delete: false
    }



    constructor() {
        super()
        this.state = {
            List: [],
            Model: this.eduModel,
            showModal: false,
            Mode: "",
            showModalDel: false,
            showModalSave: false,
            showModalDelete: false,
            errors: {},
            count: 0,
            TotalPage: 0,
            filter: {
                search: "",
                order: '',
                page: '1',
                pagesize: '5'
            }
        }
    }

    loadList = async () => {
        const respon = await eduService.getAllFilter(this.state.filter)
        const responCount = await eduService.countData()

        if (respon.success) {
            let count = 0
            if (responCount.result != undefined) {
                count = responCount.result.count
            }
            this.setState({
                List: respon.result,
                TotalPage: Math.ceil(count / this.state.filter.pagesize)
            })
        }
        console.log(this.state.List)
    }

    componentDidMount() {
        this.loadList()
    }

    createHandler = () => {
        this.setState({
            Mode: "Tambah",
            showModal: true,
            Model: this.eduModel
        })
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            showModal: false,
            errors:{}
        })
    }

    cancelHandlerDel = () => {
        this.setState({
            showModalDel: false,
            showModalDelete: false,
            showModalSave: false
        })
    }

    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }


    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }

    saveHandler = async () => {
        const responName = await eduService.dupeData(this.state.Model.name)
        var name = ""
        if (responName.success) {
            if (responName.result != undefined) {
                name = responName.result.name
            }
        }
        console.log(responName.result)

        if (this.handleValidation(name)) {
            if (this.state.Mode == "Ubah") {
                this.setState({
                    Model : {
                        ...this.state.Model,
                        ['modified_by'] : this.user
                    }
                })
                const respon = await eduService.EditData(this.state.Model)
                if (respon.success) {
                    this.loadList()
                    this.setState({
                        Model: this.eduModel,
                        showModal: false,
                        showModalSave: true
                    })
                }
            }
            else {
                const respon = await eduService.addData(this.state.Model)
                console.log(respon)
                if (respon.success) {
                    this.loadList()
                    this.setState({
                        Model: this.eduModel,
                        showModal: false,
                        showModalSave: true
                    })

                }
            }
        }
    }


    editHandler = async (id) => {
        const respon = await eduService.getById(id)
        console.log(respon)
        this.setState({
            Mode: "Ubah",
            showModal: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    softDeleteHandler = async (id) => {
        const respon = await eduService.getById(id)
        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    saveHandlerDel = async () => {
        if (this.handleValidation()) {
            let model_delete = { _id:this.state.Model._id, deleted_by : this.user }
            const respon = await eduService.softDeleteData(model_delete)
            console.log(respon)
            if (respon.success) {
                this.loadList()
                this.setState({
                    showModalDel: false,
                    showModalDelete: true
                })
            }
        }
    }

    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation(cekName) {
        let fields = this.state.Model
        let errors = {}
        let formIsValid = true;

        //name
        
        if (cekName) {
            formIsValid = false
            errors["name"] = "Name is already Use"
        }
        
        if (!fields["name"] || fields["name"].trim()=="") {
            formIsValid = false
            errors["name"] = "Name cannot be empty"
        }

        this.setState({ errors: errors })
        return formIsValid
    }

    renderPagination() {
        let item = []
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }

    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pagesize"]: size
            }
        }, () => this.loadList())
    }

    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }




    render() {
        const { List, Model, showModal, showModalDel, showModalDelete, showModalSave, errors } = this.state

        return (
            <div class="container">
                {/* {JSON.stringify(List)} */}
                <div class="text-center mb-3">
                    <h1>Education Level</h1>
                </div>
                <div class="input-group col-5 mb-1 float-left">
                    <input class="form-control rounded-left" type="text" placeholder="Search by Nama" onChange={this.filterHandler("search")} />
                    <div class="input-group-append" onClick={this.loadList}>
                        <button class="btn btn-primary rounded-right" type="button">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-success mb-3 float-right" onClick={() => this.createHandler()}>+ Tambah</button>
                <div className="input-goup-append">

                    <button type="button" class="btn btn-primary dropdown-toggle " data-toggle="dropdown" aria-expanded="true">
                        Show Data
                    </button>
                    <ul class="dropdown-menu">
                        <li><a href="#" onClick={() => this.pageSizeHandler('3')} className="dropdown-item">3</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                        <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                    </ul>
                </div>
                <table class="table table-striped">
                    <thead>
                        <tr class="bg-primary text-center">

                            <th scope="col">Name</th>
                            <th scope="col">Create By</th>
                            <th scope="col">#</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            List.map(data => {
                                return (
                                    <tr class="text-center">
                                        <td>{data.name}</td>
                                        <td>{data.user}</td>
                                        <td><button class="btn btn-primary mr-2" onClick={() => this.editHandler(data._id)}>Edit</button>
                                            <button class="btn btn-danger" onClick={() => this.softDeleteHandler(data._id)}>Delete </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>

                <div class="float-right">
                    {this.renderPagination()}
                </div>

                <FormInput
                    changeHandler={this.changeHandler}
                    checkedHandler={this.checkedHandler}
                    saveHandler={this.saveHandler}
                    Model={Model}
                    showModal={showModal}
                    showModalSave={showModalSave}
                    cancelHandler={this.cancelHandler}
                    handleChange={this.handleChange}
                    errors={errors}
                    Mode={this.state.Mode}
                    showModalDel={showModalDel}
                    showModalDelete={showModalDelete}
                    cancelHandlerDel={this.cancelHandlerDel}
                    saveHandlerDel={this.saveHandlerDel}
                    handleValidation={this.handleValidation}
                />
            </div>
        )
    }
}